/* SEDA — global interactions */
(function () {
  'use strict';
  const money = (cents) => {
    const fmt = (window.SEDA && window.SEDA.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---- Sticky header shadow ---- */
  const header = document.querySelector('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Scroll reveal ---- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('in'), i * 70);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('in'));
  }

  /* ---- Smooth anchor scroll ---- */
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        const t = document.querySelector(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });

  /* ---- Drawer + overlay ---- */
  const overlay = document.querySelector('[data-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const openDrawer = () => { if (drawer) { drawer.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; } };
  const closeAll = () => {
    drawer && drawer.classList.remove('open');
    mobileMenu && mobileMenu.classList.remove('open');
    overlay && overlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-cart-toggle]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  document.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', closeAll));
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.addEventListener('click', () => { mobileMenu && mobileMenu.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }));

  /* ---- Cart rendering ---- */
  const countEls = document.querySelectorAll('[data-cart-count]');
  function renderDrawer(cart) {
    countEls.forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
    const body = document.querySelector('[data-drawer-body]');
    const sub = document.querySelector('[data-drawer-subtotal]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="muted" style="text-align:center;padding:60px 0;font-style:italic;font-family:var(--font-head);font-size:20px;">Your bag is empty.</p>';
      sub && (sub.textContent = '');
      return;
    }
    body.innerHTML = cart.items.map((it) => `
      <div class="drawer-line" data-key="${it.key}">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt=""></a>
        <div>
          <a href="${it.url}"><h4>${it.product_title}</h4></a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="rm">${it.variant_title}</div>` : ''}
          <div class="rm">Qty ${it.quantity} · ${money(it.final_price)}</div>
          <button class="rm" style="text-decoration:underline" data-remove="${it.key}">Remove</button>
        </div>
        <div style="font-size:13px">${money(it.final_line_price)}</div>
      </div>`).join('');
    sub && (sub.textContent = money(cart.total_price));
    body.querySelectorAll('[data-remove]').forEach((b) => b.addEventListener('click', () => changeItem(b.dataset.remove, 0)));
  }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json()); }
  function changeItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then((r) => r.json()).then((cart) => { renderDrawer(cart); refreshCartPage(); return cart; });
  }

  /* ---- Add to cart (AJAX) ---- */
  document.querySelectorAll('[data-add-to-cart]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(Object.fromEntries(new FormData(form))) })
        .then((r) => r.json())
        .then(() => fetchCart())
        .then((cart) => { renderDrawer(cart); openDrawer(); })
        .catch(() => { form.submit(); })
        .finally(() => { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  /* ---- Cart page line updates ---- */
  function refreshCartPage() {
    const cartRoot = document.querySelector('[data-cart-page]');
    if (cartRoot) fetchCart().then((cart) => { if (!cart.item_count) location.reload(); });
  }
  document.querySelectorAll('[data-line-remove]').forEach((b) => b.addEventListener('click', () => changeItem(b.dataset.lineRemove, 0).then(() => location.reload())));
  document.querySelectorAll('[data-line-qty]').forEach((wrap) => {
    const key = wrap.dataset.lineQty;
    wrap.querySelectorAll('[data-step]').forEach((btn) => btn.addEventListener('click', () => {
      const input = wrap.querySelector('input');
      let v = parseInt(input.value, 10) + parseInt(btn.dataset.step, 10);
      if (v < 0) v = 0;
      changeItem(key, v).then(() => location.reload());
    }));
  });

  /* ---- Quantity steppers (generic) ---- */
  document.querySelectorAll('.qty').forEach((q) => {
    const input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => {
      let v = parseInt(input.value, 10) + parseInt(b.dataset.step, 10);
      input.value = Math.max(1, v);
    }));
  });

  /* ---- Accordions ---- */
  document.querySelectorAll('.acc__head').forEach((h) => h.addEventListener('click', () => {
    const item = h.closest('.acc__item');
    const panel = item.querySelector('.acc__panel');
    const open = item.classList.toggle('open');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0';
  }));

  /* ---- Product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
      g.querySelectorAll('[data-thumb]').forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
      main.src = t.dataset.thumb;
    }));
  });

  /* ---- Product variant selection ---- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const data = window.SEDA_PRODUCT;
    if (!data) return;
    const idField = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-current-price]');
    const btn = form.querySelector('[type="submit"]');
    function selectedOptions() {
      const opts = [];
      form.querySelectorAll('[data-option-index]').forEach((el) => {
        const idx = parseInt(el.dataset.optionIndex, 10);
        if (el.type === 'radio') { if (el.checked) opts[idx] = el.value; }
        else { opts[idx] = el.value; }
      });
      return opts;
    }
    function update() {
      const opts = selectedOptions();
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (variant) {
        idField.value = variant.id;
        if (priceEl) priceEl.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : '') + money(variant.price);
        if (btn) { btn.disabled = !variant.available; btn.textContent = variant.available ? (btn.dataset.label || 'Add to bag') : 'Sold out'; }
      }
    }
    form.querySelectorAll('[data-option-index]').forEach((el) => el.addEventListener('change', update));
    update();
  });

  /* ---- Newsletter (uses Shopify customer form; graceful) ---- */
  document.querySelectorAll('[data-newsletter]').forEach((form) => {
    form.addEventListener('submit', () => {
      const wrap = form.closest('[data-newsletter-wrap]');
      // allow native submit to Shopify; show optimistic success if it's the JS-only variant
      if (form.dataset.newsletter === 'optimistic') {
        // handled by Shopify form response normally
      }
    });
  });

  // init cart count on load
  fetchCart().then(renderDrawer).catch(() => {});
})();
